import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { setWhereYouLeftData } from 'store/Dashboard/actions'
import { setWhereYouLeftFetched } from 'store/Dashboard/actions'
import AxiosInstance from 'utils/AxiosInstance'

export function useWhereYouLeftCourse() {
  const dispatch = useDispatch()

  const {
    whereYouLeftFetched,
    whereYouLeftData: {
      width,
      whereYouLeftUrl: whereYouLeftUrlRedux,
      lastActivity,
      lastCourseProgress,
    },
  } = useSelector((state) => state.dashboard)

  let coursesOverview = useSelector(
    (state) => state.dashboard.coursesOverviewsData.coursesOverview
  )

  coursesOverview =
    Object.keys(coursesOverview).length === 0 ? [] : coursesOverview

  const course = coursesOverview?.find(
    (course) => course?.name === lastActivity?.title
  )

  const validContents = course?.finishedContents?.filter((content) =>
    course.contents.includes(+content)
  )

  const percentage = Math.floor(
    (validContents?.length / course?.contents?.length) * 100
  )

  useEffect(() => {
    if (whereYouLeftFetched) return
    dispatch(setWhereYouLeftData({ loadingActivity: true }))
    const getUserlastActivity = () => {
      AxiosInstance.get('/users/self/last-activity').then((data) => {
        dispatch(
          setWhereYouLeftData({
            lastActivity: data,
            lastCourseProgress: data,
            loadingActivity: false,
          })
        )
        getLastCourseProgress(data)
        dispatch(setWhereYouLeftFetched(true))
      })
    }
    getUserlastActivity()
  }, [dispatch, whereYouLeftFetched])

  const getLastCourseProgress = (lastActivityCourse, userProgress) => {
    try {
      dispatch(setWhereYouLeftData({ loadingProgress: true }))

      const courseProgress = userProgress?.find(
        (item) => item.course_id === lastActivityCourse.course_id
      )

      dispatch(
        setWhereYouLeftData({
          lastCourseProgress: courseProgress,
          loadingProgress: false,
        })
      )
    } catch (e) {
      console.log(e)
    }
  }

  const courseStatus = lastCourseProgress && lastCourseProgress.status
  const contentTypes = {
    1: 'text',
    2: 'video',
    4: 'file',
    5: 'html',
    8: 'scorm',
    9: 'lti',
  }
  const whereYouLeftUrl =
    lastActivity &&
    lastActivity.type === 'quiz' &&
    lastCourseProgress &&
    lastCourseProgress.status > 1
      ? `/course/${lastActivity.course_id}/submission`
      : lastActivity && lastActivity.type === 'quiz'
      ? `/course/${lastActivity.course_id}/quiz`
      : lastActivity && lastActivity.type === 'content'
      ? `/course/${lastActivity.course_id}/${
          contentTypes[lastActivity.content_type]
        }/${lastActivity.content_id}`
      : ''

  // const width = courseStatus >= 3 ? 100 : courseStatus === 1 ? 67 : 33

  useEffect(() => {
    if (!width) {
      dispatch(setWhereYouLeftData({ width: percentage }))
    }
    if (!whereYouLeftUrlRedux) {
      dispatch(setWhereYouLeftData({ whereYouLeftUrl: whereYouLeftUrl }))
    }
  }, [dispatch, percentage, whereYouLeftUrl, width, whereYouLeftUrlRedux])

  return null
}
